import { createFileRoute } from "@tanstack/react-router";

import { OccupationsPage } from "../../../workspaces/work-atlas/pages/OccupationsPage";

/** `onet` opens one occupation by its O*NET-SOC code: where a project's task links. */
type WorkOccupationsSearch = { readonly onet?: string };

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/occupations")({
  validateSearch: (search: Record<string, unknown>): WorkOccupationsSearch =>
    typeof search.onet === "string" && /^\d{2}-\d{4}\.\d{2}$/.test(search.onet)
      ? { onet: search.onet }
      : {},
  component: WorkOccupationsRoute,
});

function WorkOccupationsRoute() {
  const { onet } = Route.useSearch();
  return <OccupationsPage onet={onet} />;
}
